import { Box } from "@mui/material";
import SecurityComponent from "../../components/account/security";
function SecurityPage() {
  return <Box>{<SecurityComponent />}</Box>;
}

export default SecurityPage;
